<template>
  <div class="flex min-h-screen bg-slate-50 dark:bg-slate-900">
    <div id="dropdown" />

    <!-- SIDEBAR -->
    <aside
      class="relative flex-shrink-0 min-h-screen overflow-y-auto transition-all duration-300 bg-white border-r border-slate-200 dark:border-slate-700 dark:bg-slate-900"
      :class="collapsed ? 'w-[70px]' : 'w-[260px]'"
    >
      <!-- Header: Logo + Toggle Button -->
      <div class="flex items-center justify-between px-3 border-b h-14 border-slate-200 dark:border-slate-700">
        <div class="flex items-center gap-2">
          <span v-if="!collapsed" class="font-semibold text-slate-700 dark:text-slate-200">SICERDAS</span>
        </div>

        <button
          class="p-2 rounded-lg text-slate-500 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
          @click="toggleSidebar"
        >
          <Bars3Icon class="w-5 h-5" />
        </button>
      </div>

      <!-- Sidebar content -->
      <div class="flex flex-col justify-between min-h-screen">
        <div class="px-2 py-4">
          <MainMenu :collapsed="collapsed" :is-url="isUrl" :auth="auth" />
        </div>
        <div class="px-2 pb-16 border-t border-slate-200 dark:border-slate-700">
          <UserMenu :collapsed="collapsed" :auth="auth" />
        </div>
      </div>
    </aside>

    <!-- MAIN CONTENT -->
    <main class="flex-1 p-6 overflow-x-auto text-sm">
      <!-- Penanda bahwa aplikasi hanya dapat dibaca -->
      <div
        v-if="isReadOnly()"
        class="flex items-start gap-2 p-3 mb-4 text-sm border rounded-md text-amber-800 bg-amber-50 border-amber-300"
      >
        <font-awesome-icon icon="fas fa-circle-exclamation" class="mt-0.5" />
        <span>
          <strong>Mode Arsip.</strong>
          SICERDAS versi ini hanya menyimpan data historis dan bersifat
          <em>read-only</em>. Penambahan, perubahan, dan penghapusan data tidak tersedia.
        </span>
      </div>
      <flash-messages />
      <slot />
    </main>
  </div>
</template>

<script>
import MainMenu from './MainMenu.vue'
import UserMenu from './UserMenu.vue'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    MainMenu,
    UserMenu,
    Bars3Icon,
    FlashMessages,
  },
  props: {
    auth: Object,
  },
  data() {
    return {
      collapsed: false,
    }
  },
  mounted() {
    this.updateSidebarMode()
    window.addEventListener('resize', this.updateSidebarMode)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateSidebarMode)
  },
  methods: {
    isUrl(name) {
      return this.$page.url.startsWith('/' + name)
    },
    toggleSidebar() {
      this.collapsed = !this.collapsed
    },
    updateSidebarMode() {
      // Auto-collapse if screen width < 768px
      this.collapsed = window.innerWidth < 768
    },
  },
}
</script>
